
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/categories",
      function () {
        return require("private-next-pages/auto-parts/categories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/categories"])
      });
    }
  